import { SYS_BREAKPOINT_MD } from '@oneaudi/unified-web-common';
import { Layout } from '@oneaudi/unified-web-components';
import styled from 'styled-components';
export const CarCardWrapperMainStyles = styled(Layout) `
  flex: 1;

  > * {
    flex: 1;
  }

  .teaser-text {
    margin-top: 15px;
    word-break: break-word;
  }
`;
export const CarCardWrapperStyles = styled(Layout) `
  flex: 1;

  > * {
    flex: ${({ $compare }) => ($compare ? 'none' : '1')};
  }

  @media screen and (max-width: ${SYS_BREAKPOINT_MD}) {
    display: flex;
    flex-direction: column;

    .image-container-compare {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
`;
export const CarCardSelectionStyles = styled(Layout) `
  justify-content: left !important;

  .selected-engine-name {
    min-height: 48px;
  }

  .add-to-configuration-button {
    margin-top: auto;
  }
`;
